import { render, staticRenderFns } from "./SettingDoor.vue?vue&type=template&id=4021a027&"
import script from "./SettingDoor.vue?vue&type=script&lang=ts&"
export * from "./SettingDoor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports